document.addEventListener("DOMContentLoaded", function () {
  const cartContainer = document.getElementById("adf-found-current-cart");
  if (cartContainer) cartContainer.style.display = "none";

  const loadButton = document.getElementById("adf-Load-found-cart-p");
  const discardButton = document.getElementById("adf-Discard-found-cart-button");
  const combineButton = document.getElementById("adf-Combine-both-carts");

  if (discardButton) {
    discardButton.innerText = "Discard Items";
    discardButton.style.display = "block";
  }

  if (combineButton) {
    combineButton.innerText = "Keep all, and continue.";
    combineButton.style.display = "block";
  }

  if (loadButton) {
    if (discardButton || combineButton) {
      // loadButton.style.display = "none";
    } else {
      loadButton.innerText = "Load found cart and continue";
      loadButton.style.display = "block";
    }
  }
});

$(document).ready(function () {

  $(".cart-drawer-btn").click(function () {
    $(this).addClass("active");
    $(".cart-drawer-right").addClass("cart-drawer-open");
  });

  $(".cart-drawer-close-btn").click(function () {
    $(".cart-drawer-btn").removeClass("active");
    $(".cart-drawer-right").removeClass("cart-drawer-open");
  });

  const timers = {};
  const pendingQty = {};
  const running = {};
  const ops = {};

  let activeOps = 0;
  let flushTimer = null;

  function getQty($input) {
    let v = parseInt($input.val(), 10);
    if (isNaN(v) || v < 0) v = 0;
    return v;
  }

  function getItem(variantId) {
    return CartJS.cart.items.find(i => i.variant_id == variantId);
  }

  function scheduleCartGet() {
    clearTimeout(flushTimer);
    flushTimer = setTimeout(() => {
      if (activeOps === 0) CartJS.getCart();
    }, 150);
  }

  function runUpdate(variantId) {
    if (running[variantId]) return;

    const qty = pendingQty[variantId];
    if (qty === undefined) return;

    const item = getItem(variantId);

    running[variantId] = true;
    activeOps++;

    const current = qty;

    const done = () => {
      running[variantId] = false;
      activeOps--;

      if (pendingQty[variantId] !== current) {
        runUpdate(variantId);
      } else {
        scheduleCartGet();
      }
    };

    const applyChange = (key) => {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: key,
          quantity: qty
        },
        success: done,
        error: function (jqXHR) {
          var errormsg = jqXHR.responseJSON?.description || jqXHR.responseText || 'Unknown error';
          $("body").removeClass("loading");
          $(".error-message").text(errormsg);
          const match = errormsg.match(/\d+/);
          if (match) {
            showDrawer("#errorDrawer");
            const allowedQty = Number(match[0]);
            $(`input[data-pid="${variantId}"]`).val(allowedQty);
            applyAllowedQty(variantId, allowedQty);
          }
        }
      });
    };

    if (qty === 0) {
      if (item) {
        CartJS.removeItemById(variantId, { success: done, error: done });
      } else {
        done();
      }
      return;
    }

    if (item) {
      applyChange(item.key);
    } else {
      CartJS.addItem(variantId, qty, {}, {
        success: function () {
          setTimeout(() => {
            const newItem = getItem(variantId);
            if (newItem) applyChange(newItem.key);
            else done();
          }, 50);
        },
        error: function (jqXHR) {
          var errormsg = jqXHR.responseJSON?.description || jqXHR.responseText || 'Unknown error';
          $("body").removeClass("loading");
          $(".error-message").text(errormsg);
          const match = errormsg.match(/\d+/);
          if (match) {
            showDrawer("#errorDrawer");
            const allowedQty = Number(match[0]);
            $(`input[data-pid="${variantId}"]`).val(allowedQty);
            applyAllowedQty(variantId, allowedQty);
          }
        }
      });
    }
  }

  function applyAllowedQty(variantId, qty) {
    const $input = $(`input[data-pid="${variantId}"]`);
    $input.val(qty);

    const item = CartJS.cart.items.find(i => i.variant_id == variantId);

    if (qty === 0) {
      if (item) {
        CartJS.removeItemById(variantId, {
          success: function () {
            CartJS.getCart();
          }
        });
      }
      return;
    }

    if (item) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: item.key,
          quantity: qty
        },
        success: function () {
          CartJS.getCart();
        }
      });
    } else {
      CartJS.addItem(variantId, qty, {}, {
        success: function () {
          CartJS.getCart();
        }
      });
    }
  }

  function showDrawer(i) {
    $("body").addClass("loading showOverly");
    $(i).fadeIn(500);
    drawerTimeout = setTimeout(function () {
      $("body").removeClass("loading showOverly"), $(i).fadeOut(200);
    }, 8000);
  }

  function schedule(variantId, qty) {
    pendingQty[variantId] = qty;

    if (timers[variantId]) clearTimeout(timers[variantId]);

    timers[variantId] = setTimeout(() => {
      runUpdate(variantId);
    }, 600);
  }

  $(document).on("input", "input[data-pid]", function () {
    const $input = $(this);
    const pid = Number($input.data("pid"));
    schedule(pid, getQty($input));
  });

  $(document).on("click", ".qtyBtn.plus", function (e) {
    e.preventDefault();

    const $input = $(this).closest(".qtyField").find("input[data-pid]");
    const pid = Number($input.data("pid"));

    const qty = getQty($input);
    $input.val(qty);

    schedule(pid, qty);
  });

  $(document).on("click", ".qtyBtn.minus", function (e) {
    e.preventDefault();

    const $input = $(this).closest(".qtyField").find("input[data-pid]");
    const pid = Number($input.data("pid"));

    const qty = Math.max(0, getQty($input));
    $input.val(qty);

    schedule(pid, qty);
  });
  
  $(document).on("click", ".product-form__cart-submit, .product-form__cart--submit", function (e) {
    e.preventDefault();

    const $form = $(this).closest("form");

    let variantId =
      $form.find('select[name="id"]').val() ||
      $form.find('input[name="id"]').val() ||
      $form.find('input[name="product-id"]').val();

    variantId = Number(variantId);
    if (!variantId || isNaN(variantId)) return;

    let $qtyInput =
      $form.find("input[data-pid]");

    if (!$qtyInput.length) {
      $qtyInput = $form.find("input[name='quantity'], input.qty");
    }

    let qty = parseInt($qtyInput.val(), 10);
    if (isNaN(qty) || qty <= 0) qty = 1;
    console.log(variantId, qty)
    schedule(variantId, qty);
    
    setTimeout(function () {
      CartJS.getCart();
      $(document).trigger("cart.requestComplete");
    }, 900);

  });

  $(document).on("click", ".qtyField .qtyBtn.plus", function (e) {
  const $wrap = $(this).closest(".qtyField");
  if ($wrap.find("input[data-pid]").length) return;

  e.preventDefault();

  const $input = $wrap.find("input[name='quantity'], input.qty");

  let qty = parseInt($input.val(), 10);
  if (isNaN(qty)) qty = 0;

  $input.val(qty);
});

$(document).on("click", ".qtyField .qtyBtn.minus", function (e) {
  const $wrap = $(this).closest(".qtyField");
  if ($wrap.find("input[data-pid]").length) return;

  e.preventDefault();

  const $input = $wrap.find("input[name='quantity'], input.qty");

  let qty = parseInt($input.val(), 10);
  if (isNaN(qty)) qty = 0;

  $input.val(Math.max(0, qty));
});

});